export function appointmentOutdoorAnaltyics(state = { outdoor_service: 0, indoor_service: 0 }, action) {
  switch (action.type) {
    case "OUTDOOR_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.data;
    default:
      return state;
  }
}
